import { handleAxiosError } from "../common/handleAxiosError";
import { projectsApiClient } from "../common/axiosInstanceProjects";
import { IFormData } from "./types";

interface IUpdateProject {
  projectId: number;
  formData: IFormData;
}

export const updateProject = async ({ projectId, formData }: IUpdateProject) => {
  try {
    const data = await projectsApiClient.put(`/projects/${projectId}`, formData);
    return data;
  } catch (error) {
    handleAxiosError(error, "Error al crear el proyecto");
  }
};
